<template>
  <div>
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item>
          <el-date-picker
              v-model="searchForm.timeArr"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
              :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button type="primary" @click="onExport" :disabled="exportLoading" :loading="exportLoading">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
      <el-table-column prop="relation_id" label="交易单号"/>
      <el-table-column prop="create_time" label="发生时间"/>
      <el-table-column prop="type_str" label="类型"/>
      <el-table-column prop="amount" label="金额"/>
<!--      <el-table-column prop="before_amount" label="变动前金额">-->
<!--      </el-table-column>-->
      <el-table-column prop="after_amount" label="变动后金额"/>
    </el-table>
    <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import poi from "@/api/poi";
import {goExportCenter} from "../../../../../utils/tool";
import { getUserBalanceList } from '@/api/user'
const PoiModel = new poi();
export default {
  data() {
    return {
      searchForm: {
        timeArr: null
      },
      openParams:{},
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      exportLoading: false
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getParams(){
      const params = {
        ...this.searchForm
      }
      params.start_time = this.searchForm.timeArr ? this.searchForm.timeArr[0] : '';
      params.end_time = this.searchForm.timeArr ? this.searchForm.timeArr[1] : '';
      delete params.timeArr
      return {
        type: 50,
        ...this.openParams,
        ...params
      }
    },
    async getList() {
      this.loading = true
      const res = await getUserBalanceList({
        ...this.getParams(),
        page: this.params.pageNo,
        pagesize: this.params.pageSize,
      });

      if(!res.success) {
        this.$message.error(res.message);
        return;
      }
      this.tableList.list = res.data.list || [];
      this.tableList.total = res.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = this.params.pageNo;
      this.tableList.pageSize = this.params.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        timeArr: null
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'] && this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
    async onExport(){
      const params = this.getParams();
      if(!params.start_time || !params.end_time){
        this.$message.error('请选择日期')
        return;
      }

      // 后端偷懒不改接口字段
      params.startTime = params.start_time;
      params.endTime = params.end_time;
      delete params.start_time;
      delete params.end_time;

      this.exportLoading = true;
      const res = await PoiModel.exportUserBalanceLogExport({
        ...params,
      }).finally(()=>{
        this.exportLoading = false;
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.exportLoading = false;

      await goExportCenter()
    }
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/components/cashFlowList.vue